let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("abWA6")).then(() => parcelRequire('99X9R'));